export default __webpack_public_path__ + "static/media/circle-logo-380x376.b44a77ff.png";